// Admin Supabase client with service role key for bypassing RLS policies
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { config } from '@/config/env';

// Create admin client with service role key
// This client bypasses RLS policies for admin operations
export const supabaseAdmin = createClient<Database>(
  config.supabase.url,
  config.supabase.serviceRoleKey || config.supabase.anonKey, // Fallback to anon key if service role not available
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
    global: {
      headers: {
        'X-Client-Info': 'brutt-admin-console-admin',
      },
    },
  }
);

// Helper function to check if admin client is properly configured
export const isAdminClientConfigured = () => {
  return config.supabase.url && (config.supabase.serviceRoleKey || config.supabase.anonKey);
};
